import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginPerfectMatch, checkAuth } from '../features/quizCode/perfectMatchSlice';
import PerfectMatchLogin from '../components/perfectMatch/PerfectMatchLogin';
import ChooseShop, { ShopType } from '../components/perfectMatch/ChooseShop';
import StartQuiz from '../components/perfectMatch/StartQuiz';
import Quiz from '../components/perfectMatch/Quiz';
import Result from '../components/perfectMatch/Result';

const PerfectMatch: React.FC = () => {
    const [currentStep, setCurrentStep] = useState<'choose-shop' | 'start' | 'quiz' | 'result'>('choose-shop');
    const [selectedShop, setSelectedShop] = useState<ShopType | null>(null);
    const [quizAnswers, setQuizAnswers] = useState<string[]>([]);
    
    const dispatch = useDispatch<any>();
    const { isAuthenticated, authLoading, authError } = useSelector((state: any) => state.perfectMatch);

    useEffect(() => {
        // Verifică dacă există token salvat
        dispatch(checkAuth());
    }, [dispatch]);

    const handleLogin = (username: string, password: string) => {
        dispatch(loginPerfectMatch({ username, password }));
    };

    const handleShopSelected = (shop: ShopType) => {
        setSelectedShop(shop);
        setCurrentStep('start');
    };

    const handleStartQuiz = () => {
        setCurrentStep('quiz');
    };

    const handleQuizComplete = (answers: string[]) => {
        setQuizAnswers(answers);
        setCurrentStep('result');
    };

    const handleRestart = () => {
        setQuizAnswers([]);
        setCurrentStep('start');
    };

    // Arată login dacă nu e autentificat
    if (!isAuthenticated) {
        return <PerfectMatchLogin onLogin={handleLogin} loading={authLoading} error={authError} />;
    }

    // Arată flow-ul Perfect Match
    return (
        <>
            {currentStep === 'choose-shop' && <ChooseShop onShopSelected={handleShopSelected} />}
            {currentStep === 'start' && <StartQuiz onStartQuiz={handleStartQuiz} />}
            {currentStep === 'quiz' && <Quiz onQuizComplete={handleQuizComplete} />}
            {currentStep === 'result' && selectedShop && <Result shop={selectedShop} answers={quizAnswers} onRestart={handleRestart} />}
        </>
    );
};

export default PerfectMatch;